<template>
  <div class="download">
    <Nav subNav="下载" :isShowBack="1"></Nav>
    <div :class="{ 'download-wrap': true, 'download-wrap2': isCheck }">
      <div class="download-nav">
        <div class="nav-text" @click="checkClick(false)">客户端</div>
        <div class="nav-text" @click="checkClick(true)">设备端</div>
      </div>
      <div class="download_item_wrap" v-if="!isCheck">
        <div class="item-v2">
          <div class="win-text">
            <div class="win-icon"></div>
            Windows
          </div>
          <div class="icon-wrap">
            <div class="icon1"></div>
            <div class="icon2"></div>
          </div>
          <div class="win-text2">支持Win11、Win10、Win8、Win7等操作系统</div>
          <div class="btn" @click="jumpDownload($store.state.app_url.windows)">
            下载
          </div>
        </div>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon mac-icon"></div>
            MAC
          </div>
          <div class="win-text2 mac-text1">支持Mac OS 10及以上系统</div>
          <div class="win-text2 mac-text2">去AppStore搜索安装</div>
          <div
            class="btn"
            @click="openClick($store.state.app_url.mac_appstore)"
          >
            AppStore
          </div>
          <div class="btn-wrap" v-if="false">
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.mac_dmg)"
            >
              <div class="mac-btn-icon"></div>
              dmg下载
            </div>
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.mac_appstore)"
            >
              <div class="mac-btn-icon mac-btn-icon2"></div>
              AppStore
            </div>
          </div>
        </div>
        <div class="item-v2 pc-v2">
          <div class="win-text">
            <div class="win-icon pc-icon"></div>
            Web
          </div>
          <div class="pc-text">随时随地一键远程</div>
          <div class="btn" @click="openClick('https://yc.ionewu.com/')">
            打开
          </div>
        </div>
        <div class="item-v2 android-v2">
          <div class="win-text">
            <div class="win-icon android-icon"></div>
            Android
            <div
              class="apk-btn"
              @click="jumpDownload($store.state.app_url.android)"
            >
              apk下载
            </div>
          </div>
          <div class="android-qrcode"></div>
          <div class="android-text">应用市场搜索安装</div>
        </div>
        <div class="item-v2 android-v2">
          <div class="win-text">
            <div class="win-icon ios-icon"></div>
            IOS
          </div>
          <div class="android-qrcode ios-qrcode"></div>
          <div class="android-text">在appstore搜索安装</div>
        </div>
        <div class="item-v2 android-v2">
          <div class="win-text">
            <div class="win-icon miniapp-icon"></div>
            小程序
          </div>
          <div class="android-qrcode miniapp-qrcode"></div>
          <div class="android-text">扫码访问</div>
        </div>
      </div>
      <div class="download_item_wrap download_item_wrap2" v-else>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon qh-icon"></div>
            群晖
          </div>
          <div class="qh-text">DSM6系统</div>
          <div class="btn-wrap">
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.qh_arm)"
            >
              <div class="mac-btn-icon"></div>
              arm下载
            </div>
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.qh_x86)"
            >
              <div class="mac-btn-icon mac-btn-icon2"></div>
              x86下载
            </div>
          </div>
        </div>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon qh-icon"></div>
            群晖
          </div>
          <div class="qh-text">DSM7系统</div>
          <div class="btn-wrap">
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.qh_dsm7_arm)"
            >
              <div class="mac-btn-icon"></div>
              arm下载
            </div>
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.qh_dsm7_x86)"
            >
              <div class="mac-btn-icon mac-btn-icon2"></div>
              x86下载
            </div>
          </div>
        </div>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon qnas-icon"></div>
            威联通
          </div>
          <div class="qh-text">QTS</div>
          <div class="btn-wrap">
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.wlt_arm)"
            >
              <div class="mac-btn-icon"></div>
              arm下载
            </div>
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.wlt)"
            >
              <div class="mac-btn-icon mac-btn-icon2"></div>
              x86下载
            </div>
          </div>
        </div>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon twm-icon"></div>
            铁威马
          </div>
          <div class="qh-text">TOS4系统</div>
          <div class="btn-wrap">
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.twm_arm)"
            >
              <div class="mac-btn-icon"></div>
              arm下载
            </div>
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.twm)"
            >
              <div class="mac-btn-icon mac-btn-icon2"></div>
              x86下载
            </div>
          </div>
        </div>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon twm-icon"></div>
            铁威马
          </div>
          <div class="qh-text">TOS5系统</div>
          <div class="btn-wrap">
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.twm_tos5_arm)"
            >
              <div class="mac-btn-icon"></div>
              arm下载
            </div>
            <div
              class="mac-btn"
              @click="jumpDownload($store.state.app_url.twm_tos5)"
            >
              <div class="mac-btn-icon mac-btn-icon2"></div>
              x86下载
            </div>
          </div>
        </div>

        <div class="item-v2 pc-v2" v-if="false">
          <div class="win-text">
            <div class="win-icon"></div>
            Windows
          </div>
          <div class="qh-text">Windows</div>
          <div class="btn">下载</div>
        </div>
        <div class="item-v2">
          <div class="win-text">
            <div class="win-icon"></div>
            Windows
          </div>
          <div class="icon-wrap">
            <div class="icon1"></div>
            <div class="icon2"></div>
          </div>
          <div class="win-text2">支持Win11、Win10、Win8、Win7等操作系统</div>
          <div
            class="btn"
            @click="jumpDownload($store.state.app_url.windows_server)"
          >
            下载
          </div>
        </div>
        <div class="item-v2 mac-v2">
          <div class="win-text">
            <div class="win-icon mac-icon"></div>
            MAC
          </div>
          <div class="win-text2 mac-text1">支持Mac OS 10及以上系统</div>
          <div class="win-text2 mac-text2">去AppStore搜索安装</div>
          <div
            class="btn"
            @click="openClick($store.state.app_url.mac_appstore)"
          >
            AppStore
          </div>
          <div
            class="btn"
            @click="jumpDownload($store.state.app_url.mac_server_dmg)"
            v-if="false"
          >
            <div class="mac-btn-icon"></div>
            dmg下载
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
export default {
  name: "Download",
  components: {
    Nav,
  },
  data: function () {
    return {
      isShowQrcode: true,
      isCheck: false,
    };
  },
  methods: {
    checkClick: function (data) {
      let _that = this;
      _that.isCheck = data;
    },
    openClick: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
    showQrcode: function () {
      this.isShowQrcode = true;
    },
    hideQrcode: function () {
      this.isShowQrcode = false;
    },
    jumpDownload: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
  },
};
</script>

<style lang="less" scoped>
.download {
  background-color: #f5f5f5;
  height: 100%;

  .download-wrap {
    position: relative;
    padding-top: 1px;
    margin: 0 auto;
    margin-top: 5px;
    width: 938px;
    height: 490px;
    /*overflow: auto;*/
    -ms-overflow-style: none;
    box-sizing: border-box;
    background-image: url(../assets/setting/download1.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .download-nav {
      position: absolute;
      left: 28px;
      .nav-text {
        display: inline-block;
        vertical-align: top;
        width: 112px;
        height: 42px;
        line-height: 42px;
        font-weight: 700;
        font-size: 16px;
        color: #000000;
        text-align: center;
        cursor: pointer;
      }
      .nav-text:last-of-type {
        margin-left: 22px;
      }
    }

    .download_item_wrap.download_item_wrap2 {
      .item-v2 {
        height: 158px;
        .icon-wrap {
          margin-top: 2px;
        }
      }
      .qh-text {
        margin-top: 15px;
      }
    }

    .download_item_wrap {
      margin-top: 74px;
      position: relative;
      padding-left: 19px;
      padding-right: 19px;
      width: 100%;
      text-align: left;
      height: 400px;
      overflow-y: scroll;

      .item-v2 {
        position: relative;
        padding-top: 1px;
        display: inline-block;
        margin-left: 6px;
        margin-right: 6px;
        margin-top: 8px;
        margin-bottom: 8px;
        vertical-align: top;
        width: 288px;
        height: 184px;
        box-sizing: border-box;
        border: 1px solid #ddd;
        border-radius: 6px;
        overflow: hidden;
        .win-text {
          margin-top: 15px;
          margin-left: 18px;
          font-weight: 700;
          font-size: 14px;
          line-height: 22px;
          color: #1c407a;
          text-align: left;
          .win-icon {
            display: inline-block;
            margin-right: 8px;
            width: 21px;
            height: 21px;
            vertical-align: top;
            background-image: url(../assets/download/download3.svg);
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .mac-icon {
            margin-top: -2px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/download4.svg);
          }
          .pc-icon {
            margin-top: -2px;
            width: 24px;
            height: 24px;
            background-image: url(../assets/download/download5.svg);
          }
          .android-icon {
            margin-top: -4px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/download6.svg);
          }
          .ios-icon {
            margin-top: -5px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/ios-icon.png);
          }
          .miniapp-icon {
            margin-top: -4px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/miniapp-icon.svg);
          }
          .qh-icon {
            margin-top: -4px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/qh-icon2.svg);
          }
          .twm-icon {
            margin-top: -4px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/tnas-icon.png);
          }
          .qnas-icon {
            margin-top: -4px;
            width: 28px;
            height: 28px;
            background-image: url(../assets/download/qnas-icon.png);
          }
        }
        .icon-wrap {
          margin-top: 14px;
          margin-left: 44px;
          .icon1,
          .icon2 {
            display: inline-block;
            vertical-align: top;
            width: 54px;
            height: 20px;
            background-image: url(../assets/home/node/windows_icon_02.svg);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            margin-right: 5px;
          }
          .icon2 {
            margin-left: 8px;
            background-image: url(../assets/home/node/windows_icon_01.svg);
          }
        }
        .win-text2 {
          margin: 0 auto;
          margin-top: 8px;
          width: 155px;
          text-align: center;
          color: #666666;
          font-size: 12px;
        }
        .mac-text2 {
          margin-top: 0;
        }
        .pc-text {
          margin-top: 26px;
          font-size: 16px;
          line-height: 21px;
          color: #000000;
          text-align: center;
        }
        .qh-text {
          margin-top: 20px;
          text-align: center;
          font-size: 20px;
          font-weight: bolder;
        }
        .btn {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 286px;
          height: 46px;
          line-height: 46px;
          font-weight: 700;
          font-size: 15px;
          color: #ffffff;
          text-align: center;
          background-color: #245bd2;
          cursor: pointer;
        }
        .btn:hover {
          opacity: 0.9;
        }
      }
      .mac-v2 {
        .btn-wrap {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 286px;
          height: 46px;
          line-height: 46px;
          text-align: center;
          font-weight: 700;
          font-size: 15px;
          color: #ffffff;
          .mac-btn {
            display: inline-block;
            vertical-align: top;
            width: 142px;
            height: 100%;
            background-color: #245bd2;
            cursor: pointer;
            .mac-btn-icon {
              display: inline-block;
              margin-top: 15px;
              margin-right: 4px;
              vertical-align: top;
              background-image: url(../assets/download/title-icon-white.svg);
              background-repeat: no-repeat;
              background-size: 100% 100%;
              width: 14px;
              height: 14px;
            }
          }
          .mac-btn:last-of-type {
            width: 143px;
            margin-left: 1px;
          }
          .mac-btn:hover {
            opacity: 0.9;
          }
        }
      }
      .android-v2 {
        .apk-btn {
          display: inline-block;
          margin-left: 90px;
          vertical-align: top;
          font-size: 16px;
          color: #000000;
          font-weight: 400;
          line-height: 22px;
        }
        .android-qrcode {
          margin: 0 auto;
          margin-top: 8px;
          width: 100px;
          height: 100px;
          background-image: url(../assets/download/phone-qrcode.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
        .ios-qrcode {
          background-image: url(../assets/download/ios-qrcode.png);
        }
        .miniapp-qrcode {
          background-image: url(../assets/download/miniapp-icon2.png);
        }
        .android-text {
          margin-top: 8px;
          font-size: 16px;
          line-height: 21px;
          color: #000000;
          text-align: center;
        }
      }

      .download_item {
        border: 1px solid #000000;
        display: inline-block;
        position: relative;
        margin-right: 15px;
        margin-top: 15px;
        vertical-align: top;
        width: 288px;
        height: 184px;
        overflow: hidden;
        background-color: #ffffff;
        box-sizing: border-box;

        .download_item_top {
          height: 48px;
          .item_icon {
            margin-left: 18px;
            margin-top: 12px;
            width: 28px;
            height: 28px;
            background-size: 100% 100%;
            display: inline-block;
            vertical-align: top;
          }
          .item_name {
            display: inline-block;
            vertical-align: top;
            height: 31px;
            line-height: 31px;
            margin-top: 10px;
            margin-left: 6px;
            font-size: 14px;
            width: 140px;
            text-align: left;
          }
        }

        .download_item_middle {
          text-align: center;
          font-size: 20px;
          font-weight: bolder;
          margin-top: 15px;
        }
        .download_item_bottom {
          height: 68px;
          width: 100%;
          box-sizing: border-box;
          padding-left: 12px;
          padding-top: 3px;

          .url_item {
            width: 93px;
            line-height: 31px;
            height: 31px;
            display: inline-block;
            vertical-align: top;
            color: #1f5de3;
            border-radius: 2px;
            font-size: 12px;
            padding-left: 28px;
            box-sizing: border-box;
            background-image: url(../assets/download/arrow-icon.svg);
            background-repeat: no-repeat;
            background-size: 14px 14px;
            background-position: 10px center;
          }
          .url_item:hover {
            // font-weight: bolder;
            opacity: 0.9;
            cursor: pointer;
          }
        }
        .download_item_desc {
          width: 155px;
          color: rgba(102, 102, 102, 1);
          font-size: 12px;
          margin: 0 auto;
          margin-top: 3px;
          text-align: center;
        }
        .download_btn {
          color: rgba(36, 91, 210, 1);
          font-size: 12px;
          padding-right: 22px;
          background-image: url(../assets/download/arrow-icon.svg);
          background-size: 16px 16px;
          background-repeat: no-repeat;
          background-position: right center;
          position: absolute;
          bottom: 14px;
          right: 14px;
        }
        .download_btn:hover {
          cursor: pointer;
          opacity: 0.9;
        }

        .download_qrcode_btn {
          background-image: url(../assets/download/qrcode-icon.svg);
        }
        .download_qrcode {
          width: 88px;
          height: 112px;
          background-image: url(../assets/download/qrcode.jpg);
          background-position: left top;
          background-repeat: no-repeat;
          background-size: 88px 88px;
          position: absolute;
          bottom: 4px;
          right: 60px;
          .download_item_desc {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 20px;
            line-height: 20px;
          }
        }

        .download_qrcode.android_qrcode {
          background-image: url(../assets/download/android_qrcode.png);
          .download_item_desc:hover {
            text-decoration: underline;
            cursor: pointer;
            opacity: 0.9;
          }
        }

        .download_qrcode.phone_qrcode {
          background-image: url(../assets/download/phone-qrcode.png);
          .download_item_desc:hover {
            text-decoration: underline;
            cursor: pointer;
            opacity: 0.9;
          }
        }

        .download_qrcode.ios_qrcode {
          background-image: url(../assets/download/ios-qrcode.png);
        }

        .download_url_items {
          background-color: #ffffff;
          color: #ffffff;
          position: absolute;
          left: 0;
          width: 100%;
          bottom: 0;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          text-align: center;
          .download_url_item {
            background-color: #245bd2;
            display: inline-block;
            vertical-align: top;
            box-sizing: border-box;
          }
          .download_url_item.download_url_item_single {
            width: 100%;
            background-position: 75px center;
            padding-left: 10px;
          }
          .download_url_item:nth-child(1) {
            border-right: 1px solid #ffffff;
          }
          .download_url_item.download_url_item_single:nth-child(1) {
            border: none;
          }
          .download_url_item:hover {
            cursor: pointer;
            opacity: 0.9;
          }
        }
      }
      .download_item_android_bottom_tips {
        display: block;
        position: absolute;
        top: 180px;
        left: 460px;
        width: 200px;
        text-align: center;
        height: 20px;
        font-size: 13px;
        color: #666666;
      }
      .download_item_qh {
        // background-color: #f2f6ff;
        .item_name {
          margin-top: 10px;
        }
        .item_icon {
          background-image: url(../assets/download/qh-icon2.svg);
        }
        .download_item_bottom {
          background-color: rgba(204, 208, 250, 0.5);
          .url_item {
            // background-color: rgba(204, 208, 250, 0.5);
          }
          .url_item:hover {
            background-color: #ebf0fe;
          }
        }
      }

      .download_item_twm {
        // background-color: #f2f6ff;
        .item_name {
          margin-top: 10px;
        }
        .item_icon {
          background-image: url(../assets/download/tnas-icon.png);
        }
        .download_item_bottom {
          background-color: rgba(204, 208, 250, 0.5);
          .url_item {
            // background-color: rgba(204, 208, 250, 0.5);
          }
          .url_item:hover {
            background-color: #ebf0fe;
          }
        }
      }

      .download_item_wlt {
        // background-color: #f2f6ff;
        .item_name {
          margin-top: 10px;
        }
        .item_icon {
          background-image: url(../assets/download/qnas-icon.png);
        }
        .download_item_bottom {
          background-color: rgba(204, 208, 250, 0.5);
          .url_item {
            // background-color: rgba(204, 208, 250, 0.5);
          }
          .url_item:hover {
            background-color: #ebf0fe;
          }
        }
      }

      .download_item_windows {
        .item_icon {
          background-image: url(../assets/download/windows-icon.svg);
        }
      }
      .download_item_miniapp {
        .item_icon {
          background-image: url(../assets/download/miniapp-icon.svg);
        }
      }

      .download_item_android {
        .item_icon {
          background-image: url(../assets/download/android-icon.png);
        }
      }

      .download_item_phone {
        .item_icon {
          background-image: url(../assets/download/phone-icon.png);
        }
      }

      .download_item_ios {
        .item_icon {
          background-image: url(../assets/download/ios-icon.png);
        }
      }

      .install-client-icons {
        margin-top: 0px;
        margin-left: 52px;
        .install-client-icon {
          width: 54px;
          height: 20px;
          display: inline-block;
          background-size: 100% 100%;
          margin-right: 8px;
        }
        .install-client-icon-01 {
          background-image: url(../assets/home/node/windows_icon_02.svg);
        }
        .install-client-icon-02 {
          background-image: url(../assets/home/node/windows_icon_01.svg);
        }
      }
    }
  }
  .download-wrap2 {
    background-image: url(../assets/setting/download2.png);
  }
}
.download_content_wrap {
  width: 938px;
  height: 490px;
  margin: 0 auto;
  margin-top: 5px;
  border: 1px solid #c9d9e4;
  border-radius: 5px;
  background-color: #ffffff;
  overflow-y: scroll;
  background-image: url(../assets/setting/bg.png);
  background-size: 100% 100%;
  -ms-overflow-style: none;
  .download_title_wrap {
    width: 900px;
    border-bottom: 1px solid #f5f5f5;
    margin: 0 auto;
    margin-top: 15px;
    .download_title {
      width: 108px;
      height: 33px;
      line-height: 34px;
      font-size: 15px;
      color: #1c1f28;
      background-color: #e7eeff;
      // background-image: url(../assets/download/title-icon.svg);
      background-size: 17px 17px;
      background-position: 20px center;
      background-repeat: no-repeat;
      box-sizing: border-box;
      // padding-left: 44px;
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      text-align: center;
      font-weight: bolder;
    }
  }
  .download_agent_title_wrap {
    margin-top: 20px;
  }

  .download_item_wrap {
    width: 910px;
    margin-left: 15px;
    margin-bottom: 20px;
    position: relative;

    // .download_item.download_item_5 {
    // 	width: 163px;
    // }

    .download_item {
      border: 1px solid #dddddd;
      display: inline-block;
      vertical-align: top;
      width: 210px;
      height: 160px;
      border-radius: 8px;
      overflow: hidden;
      // background-color: #f2f9ff;
      background-color: #ffffff;
      position: relative;
      margin-right: 15px;
      margin-top: 15px;
      .download_item_top {
        height: 48px;
        .item_icon {
          margin-left: 14px;
          margin-top: 12px;
          width: 28px;
          height: 28px;
          background-size: 100% 100%;
          display: inline-block;
          vertical-align: top;
        }
        .item_name {
          display: inline-block;
          vertical-align: top;
          height: 31px;
          line-height: 31px;
          margin-top: 10px;
          margin-left: 6px;
          font-size: 14px;
          width: 140px;
          text-align: left;
        }
      }

      .download_item_middle {
        text-align: center;
        font-size: 20px;
        font-weight: bolder;
        margin-top: 15px;
      }
      .download_item_bottom {
        height: 68px;
        width: 100%;
        box-sizing: border-box;
        padding-left: 12px;
        padding-top: 3px;

        .url_item {
          width: 93px;
          line-height: 31px;
          height: 31px;
          display: inline-block;
          vertical-align: top;
          color: #1f5de3;
          border-radius: 2px;
          font-size: 12px;
          padding-left: 28px;
          box-sizing: border-box;
          background-image: url(../assets/download/arrow-icon.svg);
          background-repeat: no-repeat;
          background-size: 14px 14px;
          background-position: 10px center;
        }
        .url_item:hover {
          // font-weight: bolder;
          opacity: 0.9;
          cursor: pointer;
        }
      }
      .download_item_desc {
        width: 155px;
        color: rgba(102, 102, 102, 1);
        font-size: 12px;
        margin: 0 auto;
        margin-top: 3px;
        text-align: center;
      }
      .download_btn {
        color: rgba(36, 91, 210, 1);
        font-size: 12px;
        padding-right: 22px;
        background-image: url(../assets/download/arrow-icon.svg);
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: right center;
        position: absolute;
        bottom: 14px;
        right: 14px;
      }
      .download_btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }

      .download_qrcode_btn {
        background-image: url(../assets/download/qrcode-icon.svg);
      }
      .download_qrcode {
        width: 88px;
        height: 112px;
        background-image: url(../assets/download/qrcode.jpg);
        background-position: left top;
        background-repeat: no-repeat;
        background-size: 88px 88px;
        position: absolute;
        bottom: 4px;
        right: 60px;
        .download_item_desc {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          line-height: 20px;
        }
      }

      .download_qrcode.android_qrcode {
        background-image: url(../assets/download/android_qrcode.png);
        .download_item_desc:hover {
          text-decoration: underline;
          cursor: pointer;
          opacity: 0.9;
        }
      }

      .download_qrcode.phone_qrcode {
        background-image: url(../assets/download/phone-qrcode.png);
        .download_item_desc:hover {
          text-decoration: underline;
          cursor: pointer;
          opacity: 0.9;
        }
      }

      .download_qrcode.ios_qrcode {
        background-image: url(../assets/download/ios-qrcode.png);
      }

      .download_url_items {
        background-color: #ffffff;
        color: #ffffff;
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 0;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        .download_url_item {
          background-color: #245bd2;
          width: 50%;
          display: inline-block;
          vertical-align: top;
          box-sizing: border-box;
          background-image: url(../assets/download/title-icon-white.svg);
          background-repeat: no-repeat;
          background-position: 15px center;
          background-size: 14px 14px;
          padding-left: 15px;
        }
        .download_url_item.download_url_item_single {
          width: 100%;
          background-position: 75px center;
        }
        .download_url_item:nth-child(1) {
          border-right: 1px solid #ffffff;
        }
        .download_url_item.download_url_item_single:nth-child(1) {
          border: none;
        }
        .download_url_item:hover {
          cursor: pointer;
          opacity: 0.9;
        }
      }
    }
    .download_item_android_bottom_tips {
      display: block;
      position: absolute;
      top: 180px;
      left: 460px;
      width: 200px;
      text-align: center;
      height: 20px;
      font-size: 13px;
      color: #666666;
    }
    .download_item_qh {
      // background-color: #f2f6ff;
      .item_name {
        margin-top: 10px;
      }
      .item_icon {
        background-image: url(../assets/download/qh-icon2.svg);
      }
      .download_item_bottom {
        background-color: rgba(204, 208, 250, 0.5);
        .url_item {
          // background-color: rgba(204, 208, 250, 0.5);
        }
        .url_item:hover {
          background-color: #ebf0fe;
        }
      }
    }

    .download_item_twm {
      // background-color: #f2f6ff;
      .item_name {
        margin-top: 10px;
      }
      .item_icon {
        background-image: url(../assets/download/tnas-icon.png);
      }
      .download_item_bottom {
        background-color: rgba(204, 208, 250, 0.5);
        .url_item {
          // background-color: rgba(204, 208, 250, 0.5);
        }
        .url_item:hover {
          background-color: #ebf0fe;
        }
      }
    }

    .download_item_wlt {
      // background-color: #f2f6ff;
      .item_name {
        margin-top: 10px;
      }
      .item_icon {
        background-image: url(../assets/download/qnas-icon.png);
      }
      .download_item_bottom {
        background-color: rgba(204, 208, 250, 0.5);
        .url_item {
          // background-color: rgba(204, 208, 250, 0.5);
        }
        .url_item:hover {
          background-color: #ebf0fe;
        }
      }
    }

    .download_item_windows {
      .item_icon {
        background-image: url(../assets/download/windows-icon.svg);
      }
    }
    .download_item_miniapp {
      .item_icon {
        background-image: url(../assets/download/miniapp-icon.svg);
      }
    }

    .download_item_android {
      .item_icon {
        background-image: url(../assets/download/android-icon.png);
      }
    }

    .download_item_phone {
      .item_icon {
        background-image: url(../assets/download/phone-icon.png);
      }
    }

    .download_item_ios {
      .item_icon {
        background-image: url(../assets/download/ios-icon.png);
      }
    }

    .install-client-icons {
      margin-top: 0px;
      margin-left: 14px;
      .install-client-icon {
        width: 54px;
        height: 20px;
        display: inline-block;
        background-size: 100% 100%;
        margin-right: 8px;
      }
      .install-client-icon-01 {
        background-image: url(../assets/home/node/windows_icon_02.svg);
      }
      .install-client-icon-02 {
        background-image: url(../assets/home/node/windows_icon_01.svg);
      }
    }
  }
}
</style>